import React from 'react';
import './Logo.scss';
import { classNameBuilder } from '../../utils/className';
import { LogoNavbar, LogoRight } from '../../assets/icons/svgIconsForJSX';
import { useNavigate } from 'react-router-dom';

interface IProps {
    isDark: boolean;
}

const Logo: React.FC<IProps> = ({ isDark = false }) => {
    const cn = classNameBuilder('logo');
    const navigate = useNavigate();

    return (
        <div
            className={cn('')}
            onClick={() => {
                navigate('/');
            }}>
            {!isDark ? (
                <>
                    <LogoNavbar className={cn('biocad-logo-icon')} useCurrentColor={true} />
                    <LogoRight className={cn('biocad-logo-icon-right')} />
                </>
            ) : (
                <>
                    <LogoNavbar className={cn('biocad-logo-icon', { isDark: isDark })} />
                    <LogoRight className={cn('biocad-logo-icon-right')} useCurrentColor={true} />
                </>
            )}
        </div>
    );
};

export default Logo;
